import React, { useEffect } from 'react'

import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { AppBar, Layout, Sidebar } from '@react-admin/ra-enterprise'
import { useTranslate, Error, useSetLocale, useLocale } from 'react-admin'

import ChangeLocale from './components/actions/changeLocale'
import Menu from './components/lists/menu'
import Logo from './images/logo'
import errorHandler from './utils/errorReporting'

const useStyles = makeStyles((theme) => ({
  logo: {
    position: 'absolute',
    transform: 'translate(0%, -50%)',
    left: '0%',
    top: '50%',
    width: '133px',
    height: '44px',
    marginLeft: '60px',
  },
  breadcrumbPanel: {
    marginBottom: '-39px',
  },
  breadcrumb: {
    fontSize: '26px',
    lineHeight: '31.2px',
    ...theme.mundi.font.lato700Normal,
  },
  appBar: {},
}))

function CustomError(props) {
  useEffect(() => {
    errorHandler.report([props.error, props.errorInfo])
  }, [props.error, props.errorInfo])

  return <Error {...props} />
}

function CustomAppBar(props) {
  const classes = useStyles()
  return (
    <AppBar {...props} className={classes.appBar}>
      <Logo width="135" height="44" alt="Logo" className={classes.logo} />
      <ChangeLocale />
    </AppBar>
  )
}

const CustomBreadcrumb = (props) => {
  const classes = useStyles()
  const translate = useTranslate()
  const [resource] = window.location.href.matchAll(/#\/([^/?]*)/g)
  const selectedRespource = resource[1]
  return (
    <div className={classes.breadcrumbPanel}>
      <Typography className={classes.breadcrumb} {...props}>
        {translate(`resources.${selectedRespource}.name`)}
      </Typography>
    </div>
  )
}

function CustomSidebar(props) {
  return <Sidebar {...props} />
}

const CustomLayout = (props) => {
  const locale = useLocale()
  const setLocale = useSetLocale()

  useEffect(() => {
    const localStorageChangeEvents = () => {
      const storageLocale = localStorage.getItem('locale')
      if (locale === storageLocale) return

      setLocale(storageLocale)
    }

    window.addEventListener('storage', localStorageChangeEvents, false)

    return () => window.removeEventListener('storage', localStorageChangeEvents)
  }, [locale, setLocale])
  return (
    <Layout
      {...props}
      appBar={() => null}
      breadcrumb={() => null}
      sidebar={() => null}
      menu={() => null}
      error={CustomError}
    />
  )
}

export default CustomLayout
